// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__2jM0k","selects":"Documents_selects__UmJqE"};